import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import axios from "react-axios";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import { Helmet } from "react-helmet";
import Container from "react-bootstrap/Container";
import { getUserPlaylists } from "~/api/getCustomPlaylists";
import { getChimneyProfile } from "~/api/getChimneyProfile";
import PlaylistCard from "./PlaylistCard";

const PlaylistUserPage = ({ match }) => {
  const dir = match.params.dir;
  const [loading, setLoading] = useState(true);
  const [playlists, setPlaylists] = useState([]);
  const [name, setName] = useState("");

  useEffect(() => {
    let cancelled = false;
    const load = async () => {
      setLoading(true);
      const [playlistResp, profileResp] = await Promise.all([
        getUserPlaylists(axios, dir, 200),
        getChimneyProfile(axios, dir).catch(() => null),
      ]);
      if (cancelled) return;
      setPlaylists((playlistResp.data && playlistResp.data.playlists) || []);
      setName((profileResp && profileResp.data && profileResp.data.full_name) || "");
      setLoading(false);
    };
    load();
    return () => {
      cancelled = true;
    };
  }, [dir]);

  const heading = name ? `${name} Playlists` : "Playlists";

  return (
    <div className="playlist-page">
      <Helmet>
        <title>{heading} | Dream Chimney</title>
        <link rel="canonical" href={`https://www.dreamchimney.com/tracks/playlists/user/${dir}`} />
      </Helmet>
      <Container fluid>
        <Row>
          <Col xs={12}>
            <h2 className="page-header">{heading}</h2>
            <p>
              <Link to={`/profile/${dir}`}>Back to profile</Link>
            </p>
          </Col>
        </Row>
        {loading ? (
          <div>Loading...</div>
        ) : (
          <Row style={{ marginTop: 20, marginBottom: 40 }}>
            {playlists.length > 0 ? (
              playlists.map((p) => (
                <Col key={p.id} xs={12} sm={12} md={6} lg={4} style={{ marginBottom: 40 }}>
                  <PlaylistCard p={p} />
                </Col>
              ))
            ) : (
              <Col xs={12}>
                <p>No playlists yet.</p>
              </Col>
            )}
          </Row>
        )}
      </Container>
    </div>
  );
};

export default PlaylistUserPage;
